module.exports = __webpack_public_path__ + "static/img/2.d6e461aa.jpg";